<div class="row justify-content-around map-div">
  <div class="col-12 map-half ">
    <mat-card class="col-12 map-content">
        <!-- <div id="map" style="z-index: 0;">
          </div> -->


          <div style="position: relative;">

            <!-- leaflet -->
            <div id="map"></div>
  
            <!-- postion  -->
            <div id="get-position">
              <button class="button1" mat-mini-fab color="" (click)="getGPS()">
                <mat-icon>my_location</mat-icon>
              </button>
            </div>
  
            <!-- spinner -->
            <div id="spinner" *ngIf="IsWait" class="col-12">
              <div class="row justify-content-center">
                <mat-spinner class="position-spinner" [diameter]="50" color="primary"></mat-spinner>
              </div>
            </div>
  
          </div>
  
    </mat-card>
  </div>
</div>